import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    map: "Carte",
    myAgenda: "Mon Agenda",
    myProfile: "Mon Profil",
    myProducts: "Mes Produits"
};

export type _BookingPages = typeof _fr;

const _en: _BookingPages = {
    map: "Map",
    myAgenda: "My Agenda",
    myProfile: "My Profile",
    myProducts: "My Products"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function BookingPages(lang?: string): _BookingPages {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}